export default __webpack_public_path__ + "click-edbd4a43657acceec084db94d65ead50.mp3";